import {
  ApplicationsAttributes,
  MastersUserAttributes,
  SubRouteAttributes,
  UsersLoginAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  ReactiveFormsModule,
  FormsModule,
  Validators,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorModule,
  MatPaginatorIntl,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import {
  IAPIItemResult,
  IAPIListResult,
  IPaginationResult,
  IPaginationResult2,
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { ICreateSettingUserBusinessPartner } from "app/modules/components/business-partners/business-partner/setting-user/create-setting-user.interface";
import { UserMasterService } from "app/modules/components/routing/sub-routes/sub-route-collaborator/user_master.service";
import { ICreateUser } from "./create-user.interface";
import { AuthService } from "app/core/auth/auth.service";
import { ApplicationService } from "app/modules/components/document/applications/applications.service";
import {
  businessPartnerRequiredValidator,
  CustomValidators,
  matchingPasswords,
} from "app/utils/helper";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MasterUserTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/master-user-type.enum";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { SalesOfficeService } from "app/modules/components/configuration/sales-office/sales-office.service";
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
  take,
} from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { LinkedDeviceComponent } from "./linked-device/linked-device.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { BusinessPartnerService } from "app/modules/components/business-partners/business-partner/business-partner.service";
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ProfileService } from "app/services/profile.service";
import { IProfileAttributes } from "app/shared/interfaces/profile.interface";
import { NavigationCacheService } from "app/core/navigation/navigation-cache.service";
import { MasterUserPaginatedInterface } from "app/modules/components/sales/order-generate/interfaces/master-user.interface";
import { ICreateTemporaryPassword } from "../temporary-passwords/dto/temporary-password.interface";
import { TemporaryPasswordService } from "../temporary-passwords/temporary-passwords.service";
import { TemporaryPasswordResultComponent } from "../temporary-password-create/temporary-password-result.component";
import { ConfirmationService } from "app/shared/services/confirmation.service";
import { ConfirmationModalType } from "app/shared/components/confirmation-modal";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { IUser } from "./interfaces/user.interface";

@Component({
  selector: "app-user",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTabsModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    HoverMenuDirective,
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
  templateUrl: "./user.component.html",
  styleUrl: "./user.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class UserComponent implements OnDestroy {
  displayedColumns: string[] = [
    "det",
    "user_login_username",
    "user_login_email",
    "user_login_first_name",
    "type",
    "action",
  ];

  dataSource = new MatTableDataSource<UsersLoginAttributes>([]);

  totalItems = 0;
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof UsersLoginAttributes = "username";
  sortDirection: "ASC" | "DESC" = "ASC";

  currentCreateUser: ICreateUser = this.initializeCreateUser();
  createForm: FormGroup;
  currentUpdateUser: any;
  editForm: FormGroup;

  getCode = getCode;
  MasterUserTypeEnum = MasterUserTypeEnum;
  typeMasterUserList: string[] = [
    ...Object.keys(MasterUserTypeEnum),
    "SOCIOS DE NEGOCIO",
  ];
  salesOfficeList: SalesOfficeAttributes[] = [];
  subRouteList: SubRouteAttributes[] = [];
  businessPartnerList: BusinessPartnerAttributes[] = [];
  searchBusiness = "";
  private searchSubjectBusiness = new Subject<string>();
  applicationList: ApplicationsAttributes[] = [];
  profileList: IProfileAttributes[] = [];
  editPassword: boolean = true;
  old_password = null;

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("alertDialog") alertDialog!: TemplateRef<any>;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  selectedPermission: any | null = null; //2 CLASS

  //BUSCADOR
  searchSubscription: Subscription;

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  originalAssignedUserList: MasterUserPaginatedInterface[] = [];
  filteredAssignedUserList: MasterUserPaginatedInterface[] = [];

  userSelectedForPassword: string = "";
  passwordForm!: FormGroup;

  constructor(
    private userMasterService: UserMasterService,
    private authService: AuthService,
    private readonly applicationService: ApplicationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly profileService: ProfileService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private readonly searchService: SearchService,
    private navigationCacheService: NavigationCacheService,
    private cdr: ChangeDetectorRef,
    private temporaryPasswordService: TemporaryPasswordService,
    private confirmationService: ConfirmationService,
    private subRouteUserService: SubRouteService,
    private handlerMessage: HandlerMessageService
  ) {
    this.passwordForm = this.fb.group({
      targetUserId: ["", Validators.required],
      reason: ["", [Validators.required, this.noWhitespaceValidator]],
      durationInHours: [
        4,
        [Validators.required, Validators.min(1), Validators.max(8)],
      ],
      searchAssignedUser: [""],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
  }

  private noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || "").trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.getList();
      }
    );
  }

  openCreatePasswordModal(element): void {
    this.userSelectedForPassword = element.user_login_username;
    this.passwordForm.get("targetUserId").setValue(element.user_login__id);
    this.passwordForm.get("reason").setValue("");
    this.passwordForm.get("durationInHours").setValue(4);

    this.dialogRef = this.dialog.open(this.actionModal, {
      width: "600px",
      disableClose: true,
    });
    this.dialogRef.afterClosed().subscribe(() => {});
  }

  onSubmitPassword(): void {
    if (this.passwordForm.invalid) return;

    const formValue: ICreateTemporaryPassword = this.passwordForm.value;

    const dataToSend: ICreateTemporaryPassword = {
      targetUserId: formValue.targetUserId,
      reason: formValue.reason,
      durationInHours: formValue.durationInHours,
    };

    this.temporaryPasswordService
      .create(dataToSend)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.dialogRef.close(true);

          this.getList();

          const username =
            res.data.targetUser.username || "Usuario desconocido";

          this.dialog.open(TemporaryPasswordResultComponent, {
            width: "400px",
            data: {
              username,
              plainPassword: res.data.plainPassword,
              expiresAt: res.data.expiresAt,
            },
          });
        },
        error: (err) =>
          this.snackBar.open(err.error?.message || "Error al crear", "Cerrar", {
            duration: 3000,
          }),
      });
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  getList(): void {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.sortActive,
      sortDirection: this.sortDirection,
    };

    this.userMasterService.getAllPaginateAllUsers(options).subscribe({
      next: (res: IPaginationResult2<any>) => {
        //V1
        /* this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0; */

        //v2
        this.dataSource.data = res?.data ?? [];
        this.totalItems = res?.pageInfo.totalCount ?? 0;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener usuarios",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction.toUpperCase() || "ASC";
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  async toggleDetails(client: UsersLoginAttributes): Promise<void> {
    //CLASS 2 TABLES
    if (this.selectedPermission && this.selectedPermission._id === client._id) {
      this.closeDetails();
      return;
    }

    await this.getApplications();
    const parents = (client as any).applications_ids
      .map((appId) => {
        const app = this.applicationList.find(
          (application) => application._id === appId
        );
        if (!app) return null;

        // Filtrar sub-aplicaciones asociadas al cliente
        const subApps = app.subApplications.filter((subApp) =>
          (client as any).sub_applications_ids.includes(subApp._id)
        );

        return {
          id: app._id,
          name: app.name,
          children: subApps.map((subApp) => ({
            id: subApp._id,
            name: subApp.name,
            type: subApp.type,
            selected: true,
          })),
        };
      })
      .filter((parent) => parent !== null);

    this.selectedPermission = {
      _id: client._id,
      parents,
    };
  }

  closeDetails(): void {
    this.selectedPermission = null;
  }

  private initializeCreateUser(): ICreateUser {
    return {
      email: "",
      password: null,
      password_confirmation: null,
      username: "",
      first_name: "",
      last_name: null,
      type: null,
      salesOfficeIds: [],
      businessPartnerId: null,
      allow_shared_user: false,
      permissions: {
        business_partner_id: "",
        applications_ids: [],
        sub_applications_ids: [],
      },
      quantity_identifiers: 1,
      profileId: null,
    };
  }

  openCreateModal(): void {
    this.currentUpdateUser = null;

    this.getApplications();
    this.fetchAllSalesOffice();
    this.fetchAllProfiles();

    this.getAllBusinessPartner();
    this.setupBusinessSearchControl();
    this.currentCreateUser = this.initializeCreateUser();
    this.createForm = this.fb.group(
      {
        first_name: [this.currentCreateUser.first_name, Validators.required],
        last_name: [this.currentCreateUser.last_name],
        email: [
          this.currentCreateUser.email,
          [Validators.required, Validators.email],
        ],
        username: [this.currentCreateUser.username, Validators.required],
        type: [this.currentCreateUser.type],
        salesOfficeIds: [this.currentCreateUser.salesOfficeIds],
        businessPartnerId: [this.currentCreateUser.businessPartnerId],
        password: [
          this.currentCreateUser.password,
          [
            Validators.required,
            CustomValidators.patternValidator(/\d/, { hasNumber: true }),
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            Validators.minLength(3),
          ],
        ],
        password_confirmation: [
          this.currentCreateUser.password_confirmation,
          Validators.required,
        ],
        allow_shared_user: [this.currentCreateUser.allow_shared_user || false],
        permissionsSA: [
          this.currentCreateUser.permissions.sub_applications_ids,
        ],
        quantity_identifiers: [
          this.currentCreateUser.quantity_identifiers || 1,
        ],
        profileId: [this.currentCreateUser.profileId],
      },
      {
        validator: [
          matchingPasswords("password", "password_confirmation"),
          businessPartnerRequiredValidator(),
        ],
      }
    );

    this.dialogRefAdd = this.dialog.open(this.addModal, {
      width: "90%",
      disableClose: true,
    });
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  async openEditModal(user: any): Promise<void> {
    //UsersLoginAttributes
    await this.getApplications();
    this.fetchAllSalesOffice();
    this.fetchAllProfiles();
    this.currentUpdateUser = {
      //...user
      _id: user.user_login_id,
      masterUserId: user._id,
      businessPartnerId: user.business_partner_id ?? null,

      first_name: user.user_login_first_name,
      last_name: user.user_login_last_name,
      username: user.user_login_username,
      email: user.user_login_email,
      type: user.type,
      salesOfficeIds: user.salesOfficeIds,
      sub_applications_ids: user.sub_applications_ids,
      quantity_identifiers: user.user_login_quantity_identifiers || 1,
      allow_shared_user: user.allow_shared_user || false,
      profileId: user.user_login_profile?._id ?? null, // Backend returns it as 'user_login_profile' with nested _id
    };

    this.getAllBusinessPartner();
    this.setupBusinessSearchControl();

    this.editForm = this.fb.group(
      {
        first_name: [this.currentUpdateUser.first_name, Validators.required],
        last_name: [this.currentUpdateUser.last_name],
        email: [
          this.currentUpdateUser.email,
          [Validators.required, Validators.email],
        ],
        username: [this.currentUpdateUser.username, Validators.required],
        type: [this.currentUpdateUser.type],
        salesOfficeIds: [
          Array.isArray(this.currentUpdateUser.salesOfficeIds)
            ? this.currentUpdateUser.salesOfficeIds
            : [],
        ],
        businessPartnerId: [this.currentUpdateUser.businessPartnerId],
        password: [
          this.currentUpdateUser.password,
          [
            CustomValidators.patternValidator(/\d/, { hasNumber: true }),
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            Validators.minLength(3),
          ],
        ],
        password_confirmation: [this.currentUpdateUser.password_confirmation],
        permissionsSA: [
          Array.isArray(this.currentUpdateUser.sub_applications_ids)
            ? this.currentUpdateUser.sub_applications_ids
            : [],
        ],
        quantity_identifiers: [this.currentUpdateUser.quantity_identifiers],
        profileId: [this.currentUpdateUser.profileId],
      },
      {
        validator: [
          matchingPasswords("password", "password_confirmation"),
          businessPartnerRequiredValidator(),
        ],
      }
    );

    this.editPassword = false;
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      width: "90%",
      disableClose: true,
    });
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      result;
    });
  }

  createUserNew(): void {
    if (!this.createForm.valid) {
      return;
    }

    let parentIds = [
      ...new Set(
        this.createForm.value.permissionsSA.map(
          (selection: any) => selection.parentId
        )
      ),
    ];

    const { permissionsSA, ...formValues } = this.createForm.value; // Desestructuramos y eliminamos 'type' de formulario

    const payload: ICreateUser = {
      ...formValues,
      username: formValues.username?.trim(),
      email: formValues.email?.trim()?.toLowerCase(),
      password: formValues.password?.trim(),
      password_confirmation: formValues.password_confirmation?.trim(),
      type:
        this.createForm.value.type === "null"
          ? null
          : this.createForm.value.type,
      profileId: this.createForm.value.profile || null, // Backend expects 'profileId' when sending
      permissions: {
        business_partner_id: this.createForm.value.businessPartnerId,
        applications_ids: parentIds,
        sub_applications_ids: this.createForm.value.permissionsSA.map(
          (selection: any) => selection.subId
        ),
      },
    };

    this.authService.createUser(payload).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        if (this.dialogRefAdd) {
          this.dialogRefAdd.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  onPasswordChange() {
    this.editForm.get("password").setValue(null);
    this.editForm.get("password_confirmation").setValue(null);
  }

  openLinkedDevice(user): void {
    const dialogRef = this.dialog.open(LinkedDeviceComponent, {
      width: "70%",
      data: user,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Cancel") {
      } else {
        if (result == "success") {
        }
      }
    });
  }

  updateUser() {
    if (!this.editForm.valid) {
      return;
    }

    if (
      this.editPassword &&
      (this.editForm.value.password == null ||
        this.editForm.value.password_confirmation == null)
    ) {
      return;
    }

    const parentId = this.applicationList
      .filter((app) => {
        return app.subApplications.some((subApp) =>
          this.editForm.value.permissionsSA.includes(subApp._id)
        );
      })
      .map((app) => app._id);

    let parentIds = [...new Set(parentId)];

    const currentUser = this.authService.user;
    const isEditingCurrentUser =
      currentUser && currentUser._id === this.currentUpdateUser._id;

    const oldProfileId = this.currentUpdateUser.profileId;
    const newProfileId = this.editForm.value.profileId;
    const profileChanged = oldProfileId !== newProfileId;

    const oldSubApps = this.currentUpdateUser.sub_applications_ids || [];
    const newSubApps = this.editForm.value.permissionsSA || [];
    const subAppsChanged =
      JSON.stringify(oldSubApps.sort()) !== JSON.stringify(newSubApps.sort());

    let payload: any = {
      user_login_id: String(this.currentUpdateUser._id),
      business_partner_id: this.editForm.value.businessPartnerId
        ? this.editForm.value.businessPartnerId
        : this.currentUpdateUser.businessPartnerId
          ? String(this.currentUpdateUser.businessPartnerId)
          : null,
      email: this.editForm.value.email?.trim()?.toLowerCase(),
      username: this.editForm.value.username?.trim(),
      type:
        this.editForm.value.type == "null" ? null : this.editForm.value.type,
      salesOfficeIds: this.editForm.value.salesOfficeIds,
      oldPass: null,
      newPass: this.editForm.value.password?.trim(),
      confirmPass: this.editForm.value.password_confirmation?.trim(),
      applications_ids: parentIds,
      sub_applications_ids: this.editForm.value.permissionsSA,
      quantity_identifiers: this.editForm.value.quantity_identifiers || 1,
      allow_shared_user: false,
      first_name: this.editForm.value.first_name,
      last_name: this.editForm.value.last_name,
      profileId: this.editForm.value.profileId,
    };

    this.userMasterService
      .updateUser(payload, this.currentUpdateUser.masterUserId)
      .subscribe({
        next: () => {
          if (isEditingCurrentUser && (profileChanged || subAppsChanged)) {
            this.navigationCacheService.refresh().subscribe({
              next: () => {
                this.snackBar.open(
                  "Perfil actualizado correctamente",
                  "Cerrar",
                  { duration: 3000 }
                );
              },
              error: () => {
                this.snackBar.open(
                  "Error al actualizar el menú de navegación",
                  "Cerrar",
                  { duration: 3000 }
                );
              },
            });
          } else {
            this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
              duration: 3000,
            });
          }

          if (this.dialogRefEdit) {
            this.dialogRefEdit.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  getApplications(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.applicationService.getApplications().subscribe({
        next: (res: ApplicationsAttributes[]) => {
          this.applicationList = res;
          resolve();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener aplicaciones",
            "Cerrar",
            { duration: 5000 }
          );
          reject(err);
        },
      });
    });
  }

  changeType() {
    const form = this.createForm || this.editForm;

    if (!form) return;

    const type = form.get("type")?.value;
    if (type === MasterUserTypeEnum.CSMOBILE_FISCAL) {
      form.get("salesOfficeIds")?.setValue([]);
    } else {
      form.get("businessPartnerId")?.setValue(null);
    }

    form.updateValueAndValidity(); // Revalidar si tienes validaciones condicionales
  }

  //#region Filter form
  private fetchAllSalesOffice(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener oficinas de venta.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllProfiles(): void {
    this.profileService.filter().subscribe({
      next: (res) => {
        if (res.status === "success" && res.data) {
          // Only show active profiles
          this.profileList = res.data.filter(
            (profile) => profile.statusId === 1
          );
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener perfiles.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getAllBusinessPartner(): void {
    const options = {
      search: this.searchBusiness ? this.searchBusiness : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService
      .findAllWithCountNotBP(options, false)
      .subscribe({
        next: (
          res: IPaginationResultFrequencies<BusinessPartnerAttributes>
        ) => {
          let partners = res?.data?.data ?? [];

          const currentPartnerId = this.currentUpdateUser?.businessPartnerId;

          if (currentPartnerId) {
            const alreadyIncluded = partners.some(
              (p) => p._id === currentPartnerId
            );

            if (!alreadyIncluded) {
              this.businessPartnerService.findById(currentPartnerId).subscribe({
                next: (partner: IRequestResult<BusinessPartnerAttributes>) => {
                  partners = [partner.data, ...partners];
                  this.businessPartnerList = partners;
                },
                error: (err) => {
                  this.snackBar.open(
                    "Error al cargar el socio de negocio actual",
                    "Cerrar",
                    { duration: 3000 }
                  );
                  this.businessPartnerList = partners;
                },
              });
            } else {
              this.businessPartnerList = partners;
            }
          } else {
            this.businessPartnerList = partners;
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al traer registros",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  changueOptionsBusiness(event) {
    this.searchSubjectBusiness.next(event);
  }

  private setupBusinessSearchControl(): void {
    this.searchSubjectBusiness
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchBusiness = searchTerm;
          this.getAllBusinessPartner();
        }
      });
  }
  //#endregion


  //#region ELIMINAR USUARIO
  deleteUser(user: IUser): void {
    let descriptionText: string;
    //  Obtener rutas asignadas al usuario
    this.subRouteUserService.findToUserSubRoute(user._id).subscribe({
      next: (res) => {
        const subRoutes = res.data || [];

        // Construir info de rutas para mostrar en el modal
        const routesInfo =
          subRoutes.length > 0
            ? subRoutes
                .map((r) => `${r.name} (${r.externalKeys.code})`)
                .join(", ")
            : null;


        if (subRoutes.length > 0) {
          const routesInfoHtml = subRoutes
            .map(
              (r) =>
                `<li><span class="text-orange-600 font-semibold">${r.externalKeys.code}</span> - ${r.name}</li>`
            )
            .join("");

          descriptionText = `
                        <div>
                          <p class="font-semibold mb-2">El usuario ${user.user_login_username} esta asignado a la ruta:</p>
                          <ul class="list-disc ml-5 mb-3">
                            ${routesInfoHtml}
                          </ul>
                          <p class="text-sm text-orange-600">
                           ⚠️ <strong>Advertencia:</strong> Primero debe ser eliminado de la ruta.
                          </p>
                        </div>
                      `;
        } else {
          descriptionText = `¿Está seguro de eliminar el usuario ${user.user_login_username}?`;
        }

        this.confirmationService
          .confirm({
            title: "Eliminar Usuario",
            description: descriptionText,
            type: ConfirmationModalType.DANGER,
            descriptionIcon: "delete",
            confirmButtonText: "Eliminar",
            customWidth: 500,
          })
          .subscribe((confirmed) => {
            if (!confirmed) return;

            if (subRoutes.length > 0) {
              this.handlerMessage.warning({
                message: `No se puede eliminar al usuario ${user.user_login_username} porque pertenece a la ruta: ${routesInfo}. Primero debe ser eliminado de esa ruta.`,
                alternativeMessage: "Error al eliminar usuario",
              });
              return;
            }

            // 4️⃣ Eliminar usuario
            this.userMasterService.deleteUser(user._id).subscribe({
              next: (resDelete: any) => {
                const deleted = resDelete.data?._deleted;
                const text = deleted
                  ? `Usuario ${user.user_login_username} fue eliminado exitosamente`
                  : `No se pudo eliminar al usuario ${user.user_login_username}`;
                this.handlerMessage.success({
                  message: text,
                  alternativeMessage: "Usuario eliminado exitosamente",
                  statusCode: 200,
                });
                if (deleted) this.getList();
              },
              error: (err) => {
                this.handlerMessage.error({
                  message: err?.error?.message,
                  alternativeMessage: "Error al eliminar usuario",
                  statusCode: err?.status,
                });
              },
            });
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener rutas del usuario",
          statusCode: err?.status,
        });
      },
    });
  }

  //#endregion

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
